import React, { useState, memo } from 'react';
import { GlassMagnifier } from 'react-image-magnifiers';
import './FilePreviewRenderer.css';

/**
 * ImageWithZoom Component
 * Displays an image with a circular magnifying lens zoom effect on hover
 * Uses react-image-magnifiers library with scroll-based zoom control
 * @param {string} src - Image source URL
 * @param {string} alt - Image alt text
 */
const ImageWithZoom = memo(({ src, alt = 'Preview' }) => {
  const [zoomLevel, setZoomLevel] = useState(2.5);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.3 : 0.3;
    setZoomLevel((prev) => {
      const newZoom = prev + delta;
      // Limit zoom between 1.5x and 5x
      return Math.min(Math.max(newZoom, 1.5), 5);
    });
  };

  return (
    <div className="image-zoom-container" onWheel={handleWheel}>
      <GlassMagnifier
        imageSrc={src}
        imageAlt={alt}
        largeImageSrc={src}
        allowOverflow={true}
        magnifierSize="300px"
        magnifierBorderSize={3}
        magnifierBorderColor="rgba(0, 0, 0, 0.9)"
        magnifierBackgroundColor="#ffffff"
        magnifierOffsetX={20}
        magnifierOffsetY={0}
        square={false}
        cursorStyle="crosshair"
        style={{
          maxHeight: '295px',
          maxWidth: '455px',
          width: '100%',
        }}
        imgStyle={{
          maxHeight: '295px',
          maxWidth: '455px',
          objectFit: 'contain',
        }}
        className="magnifier-image"
      />
    </div>
  );
});

ImageWithZoom.displayName = 'ImageWithZoom';

export default ImageWithZoom;
